/**
 * Sets time of a given date
 */
export default function setTime(dt, hour, minutes) {
  return new Date(dt.getFullYear(), dt.getMonth(), dt.getDate(), hour, minutes);
}
